import React from 'react'
import '../Components/All.css'

export default function Thankspage() {
  return (
    <div>
        <div className="row mt-5">
      <h1 className='text-center' >Thank you for <span style={{color:"#dd0c2c"}}>Showing Intrest</span></h1>
      <div className="line"></div>

      <p className='text-center mt-3'>we will connect with you shortly</p>
    <center><button className='btn my-4 text-center text-white py-3 px-5' style={{backgroundColor:"#dd0c2c"}}> <i class="fa-solid fa-phone fa-beat-fade me-2" ></i> QUICK CALL +919029263511</button></center>
    </div>
    </div>
  )
}

